import React from 'react';
import { Check } from 'lucide-react';
export function ProofBar() {
  return <div id="proof-section" className="bg-luxury-charcoal border-y border-luxury-gold/20 py-12" data-id="element-121">
      <div className="max-w-6xl mx-auto px-6" data-id="element-122">
        <div className="grid md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-luxury-gold/20" data-id="element-123">
          <div className="flex flex-col items-center justify-center p-4" data-id="element-124">
            <div className="flex items-center text-luxury-gold mb-2" data-id="element-125">
              <Check className="w-4 h-4 mr-2" data-id="element-126" />
              <span className="text-sm uppercase tracking-widest" data-id="element-127">Growth</span>
            </div>
            <p className="font-serif text-3xl md:text-4xl text-white" data-id="element-128">
              1,847 followers
            </p>
            <p className="text-luxury-gray text-sm mt-1" data-id="element-129">in 90 days</p>
          </div>

          <div className="flex flex-col items-center justify-center p-4" data-id="element-130">
            <div className="flex items-center text-luxury-gold mb-2" data-id="element-131">
              <Check className="w-4 h-4 mr-2" data-id="element-132" />
              <span className="text-sm uppercase tracking-widest" data-id="element-133">
                Engagement
              </span>
            </div>
            <p className="font-serif text-3xl md:text-4xl text-white" data-id="element-134">
              4.8% rate
            </p>
            <p className="text-luxury-gray text-sm mt-1" data-id="element-135">consistent activity</p>
          </div>

          <div className="flex flex-col items-center justify-center p-4" data-id="element-136">
            <div className="flex items-center text-luxury-gold mb-2" data-id="element-137">
              <Check className="w-4 h-4 mr-2" data-id="element-138" />
              <span className="text-sm uppercase tracking-widest" data-id="element-139">Revenue</span>
            </div>
            <p className="font-serif text-3xl md:text-4xl text-white" data-id="element-140">
              $77,509+
            </p>
            <p className="text-luxury-gray text-sm mt-1" data-id="element-141">documented earnings</p>
          </div>
        </div>
      </div>
    </div>;
}